<template>
    <div class="dynamic-root" :class="{ gray: gray }">
        <!-- <div v-show="showMask" class="loading-mask"></div> -->
        <Header v-if="showHeader" />
        <!-- 浮窗-在线客服 -->
        <customer-service v-show="showCustomer"></customer-service>
        <router-view></router-view>
        <Footer v-if="showFooter" />
    </div>
</template>

<script>
import Header from '@/components/header/'
import Footer from '@/components/footer'
import Customer from '@/components/overlay/customer'
import global from '../util/globalVar'
import { mapState, mapMutations } from 'vuex'
import ajax from '../api/ajax'
export default {
    components: {
        Header,
        Footer,
        'customer-service': Customer
    },
    props: {
        noHead: {
            type: String,
            default: 'false'
        },
        noFooter: {
            type: String,
            default: 'false'
        },
        region: {
            type: String,
            default: 'cn'
        }
    },
    computed: {
        ...mapState(['showHeader', 'showCustomer', 'showFooter']),
        showMask() {
            return window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.isPrerender
        }
    },
    data() {
        return {
            gray: false
        }
    },
    watch: {
        $route: {
            handler() {
                this.initRegionLang()
                this.setShowCustomer(false)
                if (this.$route.fullPath.indexOf('/prd/home') > -1 || this.$route.fullPath.indexOf('/dynamic_functions/index') > -1) {
                    ajax.generalSwitch().then(({ switches }) => {
                        this.gray = !!switches.grayTheme
                    })
                } else {
                    this.gray = false
                }
            },
            immediate: true
        }
    },
    created() {
        this.setShowHeader(this.noHead !== 'true')
        this.setShowFooter(this.footer !== 'true')
        this.setShowFooter(this.noFooter !== 'true')
    },
    methods: {
        ...mapMutations({
            setShowHeader: 'setShowHeader',
            setShowCustomer: 'setShowCustomer',
            setShowFooter: 'setShowFooter'
        }),
        initRegionLang() {
            global.region = this.region
            global.lang = this.$route.params.lang
        }
    }
}
</script>

<style lang="scss" scoped>
.dynamic-root {
    height: 100%;
    .loading-mask {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #fff;
        z-index: 99;
    }
}
.gray {
    -webkit-filter: grayscale(100%);

    -moz-filter: grayscale(100%);

    -ms-filter: grayscale(100%);

    -o-filter: grayscale(100%);

    filter: grayscale(100%);

    filter: gray;
}
</style>



// WEBPACK FOOTER //
// src/pages/dynamic.vue